/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Int32ApiRespModel } from '../../models/int-32-api-resp-model';

export interface ApiMasterSubMenuDeleteGet$Params {
  id?: number;
}

export function apiMasterSubMenuDeleteGet(http: HttpClient, rootUrl: string, params?: ApiMasterSubMenuDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Int32ApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterSubMenuDeleteGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Int32ApiRespModel>;
    })
  );
}

apiMasterSubMenuDeleteGet.PATH = '/api/Master/SubMenu/Delete';
